import { render, staticRenderFns } from "./Coins-Report.vue?vue&type=template&id=17931b41&scoped=true&"
import script from "./Coins-Report.vue?vue&type=script&lang=js&"
export * from "./Coins-Report.vue?vue&type=script&lang=js&"
import style0 from "./Coins-Report.vue?vue&type=style&index=0&id=17931b41&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17931b41",
  null
  
)

export default component.exports